// @flow weak

import {combineReducers} from 'redux';
import {
  ACTIVATION_REQUEST, ACTIVATION_SUCCESS,
  ACTIVATION_FAILURE, GET_USER_REQUEST,
  GET_USER_SUCCESS, GET_USER_FAILURE,
} from '../actions/activation';

const isFetching = (state = false, action) => {
  switch (action.type) {
    case GET_USER_REQUEST:
    case ACTIVATION_REQUEST:
      return true;
    case GET_USER_SUCCESS:
    case GET_USER_FAILURE:
    case ACTIVATION_SUCCESS:
    case ACTIVATION_FAILURE:
      return false;
    default:
      return state;
  }
};

const tokenError = (state = null, action) => {
  switch (action.type) {
    case GET_USER_FAILURE:
      return action.error;
    case GET_USER_REQUEST:
    case GET_USER_SUCCESS:
      return null;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case ACTIVATION_FAILURE:
      return action.error;
    case ACTIVATION_REQUEST:
    case ACTIVATION_SUCCESS:
      return null;
    default:
      return state;
  }
};

const user = (state = null, action) => {
  switch (action.type) {
    case GET_USER_SUCCESS:
      return action.user;
    case GET_USER_REQUEST:
      return null;
    default:
      return state;
  }
};

const isActivated = (state = false, action) => {
  switch (action.type) {
    case ACTIVATION_SUCCESS:
      return true;
    default:
      return state;
  }
};

const activation = combineReducers({
  isActivated,
  user,
  error,
  tokenError,
  isFetching,
});

export default activation;



// WEBPACK FOOTER //
// ./src/reducers/activation.js